import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getInvoices as getInvoicesApi,
  addNewInvoice as addNewInvoiceApi,
  updateInvoice as updateInvoiceApi,
  deleteInvoice as deleteInvoiceApi,
} from '../../helpers/fakebackend_helper';

export const getInvoices = createAsyncThunk('invoice/getInvoices', async () => {
  try {
    const response = getInvoicesApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewInvoice = createAsyncThunk(
  'invoice/addNewInvoice',
  async invoice => {
    try {
      const response = addNewInvoiceApi(invoice);
      notify.success('Invoice added successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'add invoice');
      return error;
    }
  }
);

export const updateInvoice = createAsyncThunk(
  'invoice/updateInvoice',
  async invoice => {
    try {
      const response = updateInvoiceApi(invoice);
      notify.success('Invoice updated successfully.');
      const data = await response;
      return data;
    } catch (error) {
      notify.apiError(error, 'update invoice');
      return error;
    }
  }
);

export const deleteInvoice = createAsyncThunk(
  'invoice/deleteInvoice',
  async invoice => {
    try {
      const response = deleteInvoiceApi(invoice);
      notify.success('Invoice deleted successfully.');
      return { invoice, ...response };
    } catch (error) {
      notify.apiError(error, 'delete invoice');
      return error;
    }
  }
);
